import template from './taskQuickButtonsLegacy.html';
import controller from './TaskQuickButtonsControllerLegacy';

function taskQuickButtonsLegacy() {
  return {
    restrict: 'E',
    template,
    scope: {
      task: '=',
      assigneduser: '=assigneduser',
      username: '=username',
      status: '=status'
    },
    controller: 'TaskQuickButtonsLegacyController'
  };
}

export default function (ngModule) {
  ngModule.directive('taskQuickButtonsLegacy', taskQuickButtonsLegacy);
  controller(ngModule);
}
